import { encryptAES } from 'utils/crypto'
import { baseApi } from './baseApi'
import { buildQs } from 'utils/queryString'

export const commonApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        /**  物件特色Tags列表 */
        getCommonOriginHouseTags: builder.query({
            query: () => ({
                url: `common/origin-house-tags`,
                method: 'GET',
            }),
            transformResponse: (response) => {
                const { tags = [] } = response
                const newData = tags.map(({ name: label, id: value }) => ({
                    label,
                    value,
                }))
                return newData
            },
        }),
        /** 獲取縣市資料 */
        getCommonCountries: builder.query({
            query: () => ({
                url: `common/address/countries`,
                method: 'GET',
            }),
            transformResponse: (response) => {
                const { countries = [] } = response
                const newData = countries.map(
                    ({ name: label, code: value }) => ({
                        label,
                        value,
                    })
                )
                return newData
            },
        }),
        /** 獲取特定縣市的區域(區鄉鎮市) */
        getCommonAreasByCityCode: builder.query({
            query: (cityCode) => ({
                url: `common/address/countries/${cityCode}/areas`,
                method: 'GET',
            }),
            transformResponse: (response) => {
                const { areas = [] } = response
                const newData = areas.map(({ name: label, code: value }) => ({
                    label,
                    value,
                }))
                return newData
            },
        }),
        /* 取得多個組織專屬儲存體檔案空間位置進行下載動作(檔案附件使用) */
        getCommonMultiSignedUrl: builder.query({
            query: ({ paths }) => {
                const key = 'nQ2vHEuaeq48jaybjAGvE1862wc84gW5'
                const iv = 'xk6D0TbTpK30DzLM'
                const encryptedText = encryptAES(JSON.stringify(paths), key, iv)

                return {
                    url: `common/app/multi-blob-read-signed-url`,
                    method: 'POST',
                    data: { paths_data: encryptedText },
                }
            },
        }),
        getCommonBank: builder.query({
            query: () => ({
                url: `common/banks`,
                method: 'GET',
            }),
        }),
        getCommonBankBranch: builder.query({
            query: ({ bankCode }) => ({
                url: `common/banks/${bankCode}/branchs`,
                method: 'GET',
            }),
        }),
        getCommonIotProviderSecurityInputs: builder.query({
            query: ({ providerId }) => ({
                url: `lessor/v1/iot/common/providers/${providerId}/security-inputs`,
                method: 'GET',
            }),
        }),
        // /lessor/v1/iot/common/models 取得IoT模型列表
        getIotCommonModels: builder.query({
            query: ({ providerIds, types }) => {
                const qs = buildQs({ providerIds, types })
                return {
                    url: `lessor/v1/iot/common/models?${qs}`,
                    method: 'GET',
                }
            },
            keepUnusedDataFor: 0,
        }),
    }),
})

export const {
    useGetCommonOriginHouseTagsQuery,
    useGetCommonCountriesQuery,
    useGetCommonAreasByCityCodeQuery,
    useGetCommonMultiSignedUrlQuery,
    useLazyGetCommonMultiSignedUrlQuery,
    useGetCommonBankBranchQuery,
    useGetCommonBankQuery,
    useGetCommonIotProviderSecurityInputsQuery,
    useLazyGetIotCommonModelsQuery,
} = commonApi
